import { getDateTimeString } from '@acri-tools/react-tools/utils/date';
import { nullUndefined, push_history } from '@acri-tools/react-tools/utils/global';
import React from 'react';
import store from '../store';
import { get_url_query, is_on_page, MONTHS } from './general';
import { get_default_product_type, get_product_types } from './product_types';

export const PROJECT_START = new Date('2021-10-01T00:00:00Z');

export const KPI_ORDER = [
    'production timeliness - systematic',
    'production completeness - systematic',
    'PRIP service availability',
    'dashboard operations',
    'service reporting',
    'CFI data processor anomaly reporting',
    'sentinel-3 EUMETSAT interfaces performance',
    'sentinel-3 processing orchestration',
]


export const format_date = (date:string) =>{
    let d = new Date(date);
    return `${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`
}

export const getKPIColors = (level?:number) =>{
    switch(level){
        case 1: return [ 'rgb(179, 227, 157)', 'rgb(95, 204, 45)' ];
        case 2: return [ 'rgb(203, 237, 171)', 'rgb(185, 219, 91)' ];
        // case 2: return [ 'rgb(237, 237, 171)', 'rgb(227, 227, 14)' ];
        case 3: return [ 'rgb(237, 237, 171)', 'rgb(227, 227, 14)' ];
        // case 3: return [ 'rgb(245, 223, 188)', 'rgb(240, 178, 79)' ];
        case 4: return [ 'rgb(237, 205, 190)', 'rgb(237, 118, 62)' ];
        case 5: return [ 'rgb(230, 179, 179)', 'rgb(232, 70, 70)' ];

        default: return [ 'rgb(207, 207, 207)', 'rgb(95, 95, 95)' ];
    }
}


export const get_timezone_offset = (date:Date|string = new Date()) =>{
    if(typeof date === 'string') date = new Date(date);
    return date.getTimezoneOffset() * 60000;
}
export const date_timezone_compensated = (date?:Date|string) =>{
    if(!date) return null;
    if(typeof date === 'string') date = new Date(date);
    return new Date( date.getTime() + get_timezone_offset(date) )
}
export const date_timezone_compensated_removed = (date:Date|string) =>{
    if(typeof date === 'string') date = new Date(date);
    // let base_date = date;
    // let compensated_date = new Date( date.getTime() + get_timezone_offset(date) );
    return new Date( date.getTime() - get_timezone_offset(date) )
}

export const date_day_diff = (start: string, stop: string) => {
    if(start && stop) {
        let hours = Math.round(
            (new Date(stop).getTime() - new Date(start).getTime())
            / (1000 * 3600)
        )
        if (hours >= 24) {
            let days = (hours / 24);
            return `${days.toFixed(0)} Day${days >= 2 ? 's' : ''}`
        }
        return `${hours} Hour${hours !== 1 ? 's' : ''}`
    } else {
        return '-'
    }
}


export const KPI_route_name = (kpi_name:string):string =>{
    return (kpi_name.toLowerCase()).replace(/\s/g,'_');
}

export const get_month_dates = (state?:any, set_base?:boolean) =>{
    let today = new Date();
    let startDate = `${today.getFullYear()}-${today.getMonth().toString().padStart(2, '0')}-01T00:00:00`;
    let stopDate = getDateTimeString(today, true, true);

    let base_startDate, base_stopDate;
    if(state){
        base_startDate = state.base_startDate;
        base_stopDate = state.base_stopDate;
    }

    if(set_base){
        try{
            let url_start = get_url_query('startDate');
            if(url_start) base_startDate = getDateTimeString(new Date(url_start), true, false);
            // if(url_start) base_startDate = `${new Date(url_start).toISOString().replace('Z','')}`;
        } catch(e){}
        try{
            let url_stop = get_url_query('stopDate');
            if(url_stop) base_stopDate = getDateTimeString(new Date(url_stop), true, false);
            // if(url_stop) base_stopDate = `${new Date(url_stop).toISOString().replace('Z','')}`;
        } catch(e){}
    }

    if(base_startDate) startDate = base_startDate;
    if(base_stopDate) stopDate = base_stopDate;

    return {
        // startDate: `${today.getFullYear()}-${today.getMonth().toString().padStart(2, '0')}-01T00:00:00`,
        // stopDate: getDateTimeString(today, true),
        // startDate: `${start.toISOString().replace('Z','')}`,
        // stopDate: `${end.toISOString().replace('Z','')}`,
        base_startDate,
        base_stopDate,
        startDate,
        stopDate,
        updateStartDate: startDate,
        updateStopDate: stopDate,
    }
}

export const get_kpi_product_type = (state?:any, set_base?:boolean, filtered?:boolean) =>{
    // let store_state = store.getState();
    let productType = get_default_product_type(filtered);

    let base_productType;
    if(state){
        base_productType = state.base_productType;
    }

    let product_types = get_product_types(filtered)

    if(set_base){
        let url_productType = get_url_query('productType');
        if(
            url_productType && product_types 
            && Object.keys(product_types)?.some((pt:any)=>{ return pt === url_productType })
        ){
            base_productType = url_productType;
        }
    }
    if(base_productType) productType = base_productType;

    // console.debug("PTS", {
    //     productType,
    //     base_productType
    // })
    return {
        productType,
        base_productType
    };
}
export const get_graph_mode = (state:any, set_base?:boolean, graph_modes?:Array<any>) =>{
    if(!graph_modes) return {};
    let graphMode = graph_modes?.[0]?.name;

    let base_graphMode;
    if(state){
        base_graphMode = state.base_graphMode;
    }

    if(set_base){
        let url_graphMode = get_url_query('graphMode');
        if(url_graphMode ){
            base_graphMode = graph_modes?.find((gm:any)=> gm.name === url_graphMode )?.name || undefined;
        }
    }
    if(base_graphMode) graphMode = base_graphMode;

    return {
        graphMode,
        base_graphMode
    };
}

export const KPI_color = (index:number, alpha?:boolean) =>{
    let rgb;
    switch(index){
        case 0: rgb = '22, 178, 181'; break;
        case 1: rgb = '62, 119, 199'; break;
        case 2: rgb = '189, 82, 199'; break;
        case 3: rgb = '131, 194, 48'; break;
        case 4: rgb = '81, 166, 121'; break;
        case 5: rgb = '201, 161, 91'; break;
        case 6: rgb = '217, 85, 181'; break;
        case 7: rgb = '224, 105, 90'; break;
        default: rgb = '134, 227, 201'
    }
    return alpha ? `rgba(${rgb},0.4)` : `rgb(${rgb})`
}


export const format_kpi = (kpi:any, kpi_performance_levels:any) =>{
    if(!kpi_performance_levels[kpi.kpi_definition]) throw 'Missing kpi performance level data for this kpi';

    // console.log("kpi_performance_levels[kpi.kpi_definition]",kpi_performance_levels[kpi.kpi_definition]);
    kpi_performance_levels[kpi.kpi_definition].sort((a: { id: number; }, b: { id: number; }) => (a.id > b.id) ? 1 : -1);

    let levels = [...kpi_performance_levels[kpi.kpi_definition]];
    levels.reverse()

    // timeliness handling
    if('timeliness' in kpi.value){
        let { percentage, timeliness } = kpi.value;
        for(let level of levels){
            if (((level.measurement.min <= percentage && level.measurement.max >= percentage) || percentage > 100) && level.measurement.timeliness >= timeliness){
                kpi.level = level.level;
                kpi.cost_modulation = level.cost_modulation;
                continue;
            }
        }
    }

    // value and normal percentage handling
    else if(!nullUndefined(kpi.value?.percentage)){
        let value = kpi.value.percentage;
        for(let level of levels){
            if ((level.measurement.min <= value && level.measurement.max >= value) || (value > 100)) {
                kpi.level = level.level;
                kpi.cost_modulation = level.cost_modulation;
                continue;
            }
        }
    }
    else if(!nullUndefined(kpi.value?.value)){
        let value = kpi.value.value;
        for(let level of levels){
            if (level.measurement.min <= value && level.measurement.max > value) {
                kpi.level = level.level;
                kpi.cost_modulation = level.cost_modulation;
                continue;
            }
        }
    }

    if(!kpi.level){
        kpi.level = -1;
        kpi.cost_modulation = 0;
    }

    return kpi;
    
}

export const is_on_kpi_page = (kpi_number:number) =>{
    return is_on_page(`/kpis/${KPI_route_name(KPI_ORDER[kpi_number - 1])}`)
}

export const update_kpi_url = (kpi_number:number, params:any) =>{
    push_history(`/kpis/${KPI_route_name(KPI_ORDER[kpi_number - 1])}?${Object.keys(params).map((p:string)=>{
        return `${p}=${params[p]}`;
    }).join('&')}`)
}

// export const get_product_type_id = (product_type:string) =>{
//     let store_state = store.getState();
//     return store_state.product_types?.product_types?.find((pt:any)=> pt.name === product_type )?.id
// }

// const timeline_height = 50;
// export const get_timeline_height = (product_type_count:number, with_cadu?:boolean) =>{
//     return 30 + ( with_cadu ? timeline_height : 0 ) + 30 * product_type_count
// }
const timeline_height = 50;
export const get_timeline_height = (count:number, with_cadu?:boolean) =>{
    return count * timeline_height;
}
export const get_timeline_height_2 = (count:number, offset?:number) =>{
    return count * timeline_height + (offset || 0);
}

export const refresh_page = () =>{
    return !!get_url_query('refresh');
}

export const remove_refresh_from_url = () =>{
    try{
        let queries = new URLSearchParams(window.location.search);
        queries.delete('refresh');
        return `${window.location.pathname}?${queries.toString()}`
    }
    catch(e){
        return null;
    }
}